<template>
  <v-card :loading="!selectedCategory" class="fill-height">
    <v-toolbar color="primary" dark dense class="admin__toolbar mb-3 pr-0" v-if="selectedCategory">
      <v-toolbar-title>Category: {{ selectedCategory.name }}</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-toolbar-items v-if="$vuetify.breakpoint.smAndUp">
        <v-btn flat class="mx-0" style="min-width: auto;" :input-value="grid" @click="grid = true">
          <fa-icon icon="th-large"></fa-icon>
        </v-btn>
        <v-btn
          flat
          class="mx-0"
          style="min-width: auto;"
          :input-value="!grid"
          @click="grid = false"
        >
          <fa-icon icon="list"></fa-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-card v-if="!isDocumentRoute && selectedCategory">
      <v-card-title>
        <v-btn color="secondary" :to="`document/upload`" append>
          <div class="v-icon v-icon--left">
            <fa-icon :icon="['far', 'upload']" size="xs" />
          </div>Upload Document
        </v-btn>

        <v-spacer></v-spacer>

        <v-tooltip top v-if="onEditRoute">
          <v-btn icon flat slot="activator" to="edit" append>
            <div class="v-icon">
              <fa-icon :icon="['far', 'pencil-alt']" size="xs" />
            </div>
          </v-btn>
          <span>Edit</span>
        </v-tooltip>
        <v-tooltip top v-else>
          <v-btn icon flat slot="activator" @click="onCancel" append>
            <div class="v-icon">
              <fa-icon :icon="['far', 'times']" size="xs" />
            </div>
          </v-btn>
          <span>Cancel</span>
        </v-tooltip>
      </v-card-title>
    </v-card>

    <v-fade-transition mode="out-in" appear>
      <router-view
        :grid="grid"
        :onEditRoute="onEditRoute"
        :key="$route.fullPath"
        v-if="selectedCategory"
      ></router-view>
    </v-fade-transition>
  </v-card>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  data() {
    return {
      grid: true
    };
  },

  props: {
    slug: {
      default: ""
    }
  },

  methods: {
    ...mapActions("document_center", ["getCategory"]),
    ...mapMutations("document_center", ["setSelectedCategory"]),

    onCancel(e) {
      this.$router.back();

      return false;
    }
  },

  computed: {
    ...mapGetters("document_center", ["selectedCategory"]),

    category() {
      return this.selectedCategory || {};
    },

    onEditRoute() {
      return this.$route.fullPath.indexOf("edit") === -1;
    },

    isDocumentRoute() {
      return /\/document(\/(\d+|upload))?(\/edit)?\/?$/.test(
        this.$route.fullPath
      );
    },

    categorySlug() {
      return this.slug;
    }
  },

  created() {
    this.setSelectedCategory(this.categorySlug);

    this.getCategory({
      slug: this.categorySlug,
      withDocuments: true
    });
  }
};
</script>
